import { webappGetWithOrigin } from 'Fetch';

import { FeatureFlagName, FeatureFlagsType } from 'Utilities/analytics/kameleoon/featureFlags';

import { FeatureFlagRequestQueryClient } from './api.types';

// Seller Webapp endpoints
export const getKameleoonFeatureFlag = async <T extends FeatureFlagName>(
  payload: FeatureFlagRequestQueryClient<T>,
): Promise<FeatureFlagsType[T]> =>
  webappGetWithOrigin('/feature-flag', payload);
